import { render, staticRenderFns } from "./PlateTextItem.vue?vue&type=template&id=3fb246f8&scoped=true"
import script from "./PlateTextItem.vue?vue&type=script&lang=js"
export * from "./PlateTextItem.vue?vue&type=script&lang=js"
import style0 from "./PlateTextItem.vue?vue&type=style&index=0&id=3fb246f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb246f8",
  null
  
)

export default component.exports